"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/policySummaryController',["require", "exports", "controllers/abortingRequest", "providers/ajaxSettingsProvider"], function (require, exports, abortingRequest, ajaxSettingsProvider) {
    "use strict";

    var PolicySummaryController = function () {
        function PolicySummaryController() {
            _classCallCheck(this, PolicySummaryController);
        }

        _createClass(PolicySummaryController, [{
            key: "getPolicySummary",
            value: function getPolicySummary(data) {
                return abortingRequest.send('/api/policySummary/GetPolicySummary', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getPolicySummaryBlob",
            value: function getPolicySummaryBlob(data, allowMultipleOverride) {
                return abortingRequest.send('/api/policySummary/GetPolicySummaryBlob', ajaxSettingsProvider.httpPost(data), allowMultipleOverride);
            }
        }]);

        return PolicySummaryController;
    }();

    return new PolicySummaryController();
});
//# sourceMappingURL=policySummaryController.js.map;
